import '../sass/style.scss';

import '../components/hamburger/hamburger.js';